/*
 * Purpose : Tool sales Home Page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, {useState, useContext} from 'react';
import { Card, CardDeck } from 'reactstrap';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ButtonM from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
//import { NavLink } from 'react-router-dom';

import Aux from '../../hoc/Auxilliary/Auxilliary';
import ViewLogo from '../../assets/ViewTrans.png';
import Formlogo from '../../assets/Form.jpg';
import AppContext from './../../context/app-context';

import AlertModal from '../UI/modals/alertModal';

const ToolSalesFormHome = (props) => {
    const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,          
          display:"flex"
        },
        paper: {
          height: 100,
          width: 100,
        },
        control: {
          padding: theme.spacing(2),
        },
        cardDeck: {
            align:"center", 
            //margin:"5% 5%"
            marginTop:"5%",
            marginRight:"5%",
            marginBottom:"5%",
            marginLeft:"5%",
            // display:"flex",
            // flexWrap:"wrap",
            flex:"auto",
            justifyContent: "center",

        },
        card: {
            borderRadius: "8px",
            //boxShadow: "6px 8px 8px 8px #C0C0C0",
            boxShadow: "6px 6px 6px 6px #E0E0E0",//rgba(60, 61, 65, 0.05)",
            //padding:"1em",
            textAlign: "center",
            //width: "257px"
            border:"0px solid rgba(0,0,0,.125)",
            //height:"360px",
            //width: "85%",
            minWidth:"auto",
            marginBottom:"15px !important",
            //justifyContent: "center",

        },
        cardActionArea: {
            align:"center",
            marginTop:"10px !important",
            marginBottom:"50px"
        },
        cardAction: {
            alignSelf: "center",
            position:"absolute",
            bottom:"0"
        },
        image: {
            borderRadius: "20%",
            width:"100px"
        },
      }));

      const classes = useStyles();
      //using context api in functional component
      const appContext = useContext(AppContext)
      let history = useHistory();

      const [alertModal, setAlertModal] = useState(false)

      // to check the login user role and redirect
      const checkUserRole = async (path) => {
        //console.log(appContext.role.indexOf("Tool Sales"))
        ( appContext.role !== "Tool Sales Viewer" && appContext.role !== "Common Viewer" )
        ? history.push(path) 
        : path==="/toolsales/transactions"
        ? history.push(path)
        : setAlertModal(true)
    }
      
    return(
        <Aux>
            <AlertModal open={alertModal} msg="You do not have rights to access this page.!" handler={setAlertModal}/>
            <Grid container className={classes.root}>
                <CardDeck className={classes.cardDeck}>
                <Card className={classes.card}>
                        {/* <NavLink style={{ textDecoration: 'none',color: 'black' }} to='/toolsales/transactions' exact> */}
                        <CardActionArea className={classes.cardActionArea} onClick={()=>checkUserRole('/toolsales/transactions')} >
                            <span>
                                <img src={ViewLogo} alt="logo" className={classes.image} />
                            </span>
                            <CardContent>
                            <Typography gutterBottom variant="h4" component="h2">
                                View Transactions
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="h5">
                                View All the Transactions
                            </Typography>
                            </CardContent>
                        </CardActionArea>
                        {/* </NavLink> */}
                        <CardActions className={classes.cardAction}>
                            {/* <NavLink style={{ textDecoration: 'none' }} to='/toolsales/transactions' exact> */}
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={()=>checkUserRole('/toolsales/transactions')} >
                                <h5><b>Transactions</b></h5>
                            </ButtonM>
                            {/* </NavLink> */}
                        </CardActions>
                    </Card>
                    <Card className={classes.card}>
                        {/* <NavLink style={{ textDecoration: 'none',color: 'black' }} to='/toolsales/form' exact> */}
                        <CardActionArea className={classes.cardActionArea} onClick={()=>checkUserRole('/toolsales/form')} >
                            <span>
                                <img src={Formlogo} alt="form logo" className={classes.image} />
                            </span>
                            <CardContent>
                            <Typography gutterBottom variant="h4" component="h2">
                                Create New Form
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="h5">
                                Create a new Tool sales form
                            </Typography>
                            </CardContent>
                        </CardActionArea>
                        {/* </NavLink> */}
                        <CardActions className={classes.cardAction}>
                            {/* <NavLink style={{ textDecoration: 'none'}} to='/toolsales/form' exact> */}
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={()=>checkUserRole('/toolsales/form')}>
                                <h5><b>Create</b></h5>
                            </ButtonM>
                            {/* </NavLink> */}
                        </CardActions>
                    </Card>                     
                </CardDeck>            
            </Grid>
        </Aux>
    );
}
export default ToolSalesFormHome;